import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@focus/focusUI";
import { InputsOrbitsContainer } from "../containers/InputsOrbitsContainer";
import { UploadPanel } from "./upload/UploadPanel";

const RESIZE_HANDLE_CLASS_NAME =
  "relative flex h-5 w-full items-center justify-center focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-sky-500 focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:hover:cursor-ns-resize after:absolute after:left-4 after:right-4 after:top-1/2 after:h-px after:-translate-y-1/2 after:bg-slate-200 hover:after:bg-sky-300 [&[data-panel-group-direction=vertical]>div]:rotate-90";

/**
 * OrbitUploadPanel renders orbit uploads and input records in a resizable page layout.
 * @returns JSX.Element
 */
export const OrbitUploadPanel = () => {
  return (
    <div className="foc-content flex flex-col overflow-hidden">

      <main className="flex min-h-0 flex-1 overflow-hidden p-5">
        <ResizablePanelGroup direction="vertical">
          <ResizablePanel
            className="min-h-0 overflow-hidden"
            defaultSize={42}
            minSize={35}
            maxSize={65}
          >
            <div className="h-full min-h-0 pb-2">
              <UploadPanel />
            </div>
          </ResizablePanel>

          <ResizableHandle
            className={RESIZE_HANDLE_CLASS_NAME}
            withHandle
          />

          <ResizablePanel className="min-h-0 overflow-hidden" minSize={35}>
            <div className="h-full min-h-0 pt-2">
              <InputsOrbitsContainer />
            </div>
          </ResizablePanel>
        </ResizablePanelGroup>
      </main>
    </div>
  );
};
